import { render, staticRenderFns } from "./ProposalTable.vue?vue&type=template&id=b51728be&scoped=true&"
import script from "./ProposalTable.vue?vue&type=script&lang=js&"
export * from "./ProposalTable.vue?vue&type=script&lang=js&"
import style0 from "./ProposalTable.vue?vue&type=style&index=0&id=b51728be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51728be",
  null
  
)

export default component.exports